import { Heart } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
  fill?: string;
}

export function HeartIcon({ className = '', size = 24, strokeWidth = 1.5, fill = 'none' }: IconProps) {
  return (
    <Heart
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
      fill={fill}
    />
  );
}
